import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

/** Panel shell: spacing from theme tokens; fill/text from `depositLimits` palette. */
export const DepositLimitsPanelRoot = withConfig(theme => styled('div', { label: 'DepositLimitsPanelRoot' })<{ isDarkMode?: boolean }>`
    padding: ${theme.star.padding.xMedium};
    width: 100%;
    border-radius: ${theme.star.radius.medium};
    background-color: ${({ isDarkMode }): string => isDarkMode === true ?   theme.star.depositLimits.bgColorSecondary : theme.star.depositLimits.bgColor };
    color: ${({ isDarkMode }): string => isDarkMode === true ? theme.star.depositLimits.txtColorTertiary : theme.star.depositLimits.txtColor };
`);
